<template>
  <div>
    <el-dialog :visible="show && step === Steps.UPLOAD_EXCEL" @close="closeUploadExcel">
      <ModalHeader slot="title" title="Nhập người dùng bằng excel" />
      <div>
        <el-button @click="handleDownloadDemoImportFile">
          <FAIcon icon="fas fa-file-download" />
          Tải file excel mẫu
        </el-button>
      </div>
      <br />
      <vue2-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-file-added="onFileAdded">
      </vue2-dropzone>
      <el-row slot="footer" class="upload-button-container">
        <el-button type="default" @click="closeAll"> Hủy bỏ</el-button>
        <el-button type="primary" @click="handleUploadFile"> Tải lên</el-button>
      </el-row>
    </el-dialog>

    <el-dialog :visible="show && step === Steps.LIST_USER" @close="closeListUser">
      <ModalHeader slot="title" title="Danh sách người dùng" />
      <el-row slot="footer" class="upload-button-container">
        <el-button @click="closeAll">Hủy bỏ</el-button>
        <el-button type="primary" @click="showCreateForm"> Xác nhận</el-button>
      </el-row>
      <div style="width: 90%; margin: auto">
        <div class="confirm-button-container">
          <div class="margin-bottom-15" style="display: inline"></div>
        </div>
        <el-table ref="multipleTable" :data="data" :row-class-name="tableRowClassName" border style="width: 100%">
          <el-table-column type="selection" :selectable="isValid" width="55" />
          <el-table-column label="Họ tên" property="name" width="250" />
          <el-table-column property="email" label="Email" width="250" />
          <el-table-column property="anonymousEmail" label="Email ảo" width="60">
            <template slot-scope="scope">{{ scope.row.anonymousEmail ? 'x' : '' }}</template>
          </el-table-column>
          <el-table-column property="pricingPlanName" label="Loại tài khoản" width="100">
            <template slot-scope="scope"><PricingPlanTag :name="scope.row.pricingPlanName" /></template>
          </el-table-column>
          <el-table-column property="description" label="Ghi chú" />
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible="step === Steps.FORM" @close="closeCreateForm">
      <div class="title_popup text-center">Thêm người dùng</div>
      <el-form
        label-width="150px"
        :model="createUserForm"
        :label-position="labelPosition"
        :rules="rules"
        :hide-required-asterisk="true"
        ref="createUserForm"
        @keyup.enter.native="handleCreateUser"
      >
        <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

        <el-form-item label="Ngày hết hạn" prop="expireTime">
          <el-date-picker
            style="width: 100%"
            v-model.number="createUserForm.expireTime"
            type="datetime"
            format="dd/MM/yyyy"
            value-format="timestamp"
            placeholder="Chọn thời gian"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Mật khẩu" style="text-align: left">
          <div>
            <el-radio v-model="defaultPasswordType" :label="false" border>Mật khẩu ngẫu nhiên </el-radio>
            <el-radio v-model="defaultPasswordType" :label="true" border>Mật khẩu mặc định </el-radio>
          </div>
        </el-form-item>
        <el-form-item label="Mật khẩu mặc định" v-if="defaultPasswordType" prop="defaultPassword">
          <el-input v-model="createUserForm.defaultPassword" type="password"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAll">Trở về</el-button>
        <CommonButton :ref="refs.CREATE_USER_BUTTON" type="primary" @click="handleCreateUser">
          Tạo người dùng
        </CommonButton>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FAIcon from '@/components/common/FAIcon.vue'
import ModalHeader from '@/components/common/ModalHeader.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { apiGetDemoImportFileAsArrayBuffer, apiUploadFile, createUserFromFile } from '@/services/user_import_service.js'
import { pushArraybuffer2Client } from '@/helpers/DownloadHelper.js'
import PricingPlanTag from '@/components/common/PricingPlanTag.vue'
import CommonButton from '@/components/common/CommonButton.vue'

const Steps = {
  UPLOAD_EXCEL: 'UPLOAD_EXCEL',
  LIST_USER: 'LIST_USER',
  FORM: 'FORM',
}

export default {
  components: { CommonButton, PricingPlanTag, ModalHeader, FAIcon, vue2Dropzone },
  name: 'CreateBatchUserExcelModal',
  data() {
    return {
      show: false,
      step: null,
      Steps,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: 100,
        maxFiles: 1,
        addRemoveLinks: true,
        dictRemoveFile: 'Loại bỏ',
        dictInvalidFileType: 'Sai định dạng file',
        dictMaxFilesExceeded: 'Số lượng file tải lên vượt quá quy định',
        dictDefaultMessage: 'Tải file excel theo form mẫu (Tải file excel mẫu ở trên)',
        acceptedFiles: '.xlsx',
      },
      selectionRef: {},
      isUploading: false,
      data: {},
      isShowCreateUserForm: false,
      createUserForm: {
        defaultPassword: null,
        expireTime: new Date().getTime() + 30 * 24 * 3600 * 1000,
      },
      defaultPasswordType: false,
      labelPosition: 'left',
      pickerOptions1: {
        shortcuts: [
          {
            text: 'Today',
            onClick(picker) {
              picker.$emit('pick', new Date())
            },
          },
          {
            text: 'Yesterday',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            },
          },
          {
            text: 'A week ago',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            },
          },
        ],
      },
      rules: {
        defaultPassword: [{ min: 8, message: 'Mật khẩu tối thiểu 8 kí tự' }],
        expireTime: [
          {
            required: true,
            message: 'Nhập ngày hết hạn',
            trigger: 'change',
          },
        ],
      },
      errorMessage: null,
      isRequesting: false,
      refs: {
        CREATE_USER_BUTTON: 'CREATE_USER_BUTTON',
      },
    }
  },
  methods: {
    showModal() {
      this.show = true
      this.step = Steps.UPLOAD_EXCEL
      this.data = []
    },
    closeUploadExcel() {
      if (this.step === Steps.UPLOAD_EXCEL) {
        this.step = null
      }
    },
    closeListUser() {
      if (this.step === Steps.LIST_USER) {
        this.step = null
      }
    },
    closeCreateForm() {
      if (this.step === Steps.FORM) {
        this.step = null
      }
    },
    closeAll() {
      this.step = null
      this.data = []
    },
    onFileAdded(file) {},
    showCreateForm() {
      if (this.$refs.multipleTable.selection.length > 0) {
        this.step = Steps.FORM
      } else {
        this.$message.error('Chọn ít nhất một người')
      }
    },
    tableRowClassName({ row }) {
      if (!row.valid) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    },
    isValid(row, index) {
      return row.valid
    },
    async handleDownloadDemoImportFile() {
      let res = await apiGetDemoImportFileAsArrayBuffer()
      if (res == null) {
        this.$message.error('Có lỗi xảy ra')
      } else {
        pushArraybuffer2Client(res, 'ImportExcelUser.xlsx')
      }
    },
    async handleUploadFile() {
      if (this.$refs.myVueDropzone.getAcceptedFiles()[0]) {
        let res = await apiUploadFile(this.$refs.myVueDropzone.getAcceptedFiles()[0])
        if (res != null) {
          this.$refs.myVueDropzone.removeAllFiles()
          this.data = res
          this.step = Steps.LIST_USER
        } else {
          this.$message.error('Có lỗi xảy ra')
        }
      } else {
        this.$message.error('Không có file dữ liệu')
      }
    },
    async handleCreateUser() {
      this.errorMessage = null
      this.$refs['createUserForm'].validate(async (valid) => {
        if (valid) {
          this.$refs[this.refs.CREATE_USER_BUTTON].setLoading(true)
          let data = {
            defaultPassword: this.createUserForm.defaultPassword,
            expireTime: this.createUserForm.expireTime,
            users: this.$refs.multipleTable.selection,
          }
          let response = await createUserFromFile(data)
          if (response) {
            this.$message.success('Tạo người dùng thành công')
            this.$emit('success')
            this.closeAll()
          } else {
            this.$message.error('Có lỗi xảy ra')
          }
          this.$refs[this.refs.CREATE_USER_BUTTON].setLoading(false)
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style>
.confirm-button-container {
  text-align: right;
  margin-bottom: 10px;
  margin-right: 10px;
}

.confirm-button-container .confirm-button {
  width: 120px;
  font-size: 20px;
}

.vgt-selection-info-row.selection-info-bar {
  font-size: 18px;
}

.selection-info-bar button {
  font-size: 16px;
}

.el-table .warning-row {
  background: #fdf5e6;
}

.el-table .success-row {
  background: #ddf9dd;
}
</style>
